import { defineStore } from 'pinia'

export const useHintStore = defineStore({
    id: 'hint',

    state: () => {
        return {
            hint: null,
            clone: null,
            placement: null,
            fallbackPlacements: null,
        
            ddName: 'hint-dd',
            hydrated: false,
            closedHints: []
        }
    },

    actions: {
        async open ({clone, hint, placement, fallbackPlacements}) {
            if (this.$nuxt.$modalityStore.dropdowns.some(o => o.name == this.ddName)) return;

            this.$nuxt.$modalityStore.closeDropdowns({})

            this.clone = clone;
            this.hint = hint;
            this.placement = placement;
            this.fallbackPlacements = fallbackPlacements || null

            // Let component update hint value
            setTimeout(() => {
                this.$nuxt.$modalityStore.openDropdown({name: this.ddName});
            }, 10)
        },

        close (hint) {
            this.$nuxt.$modalityStore.closeDropdown({name: this.ddName});

            let index = this.closedHints.indexOf(hint);
            if (index < 0) this.closedHints.push(hint);

            this.$nuxt.$axios.$get('/userhints/update', {
                params: {hint},
                progress: false
            })
            .then(res => {
                this.closedHints = res.closedHints;
            })
            .catch(err => console.log(err));

            // wait for dropdown animation
            if (this.clone){
                setTimeout(() => {
                    this.clone.hintDone();
                    
                    this.clone = null;
                    this.hint = null;
                    this.placement = null;
                }, 350);
            }
        },

        restore (hint) {
            let index = this.closedHints.indexOf(hint);
            if (index < 0) this.closedHints.splice(index, 1);

            this.$nuxt.$axios.$get('/userhints/restore', {
                params: {hint},
                progress: false
            })
            .then(res => {
                this.closedHints = res.closedHints;
            })
            .catch(err => console.log(err));
        },

        async hydrate () {
            let res = await this.$nuxt.$axios.$get('/userhints/find', {
                progress: false
            })
            .catch(err => console.log(err));
            if (!res) return;

            this.closedHints = res.closedHints;
            this.hydrated = true;
        }
    }
})
